module.exports = __webpack_public_path__ + "img/banner-3-4@2x.d7486e98.jpg";